module.exports = __webpack_public_path__ + "img/bindphone_bg.fc3918f1.png";